import React from 'react'
import Greater from './Greater'
import { greaterShow } from '../../pages/show-special/greater-ny-dental-meeting'
import { greaterShowpro } from '../../pages/show-special/greater-ny-dental-meeting'
import { product } from '../../pages/show-special/greater-ny-dental-meeting'

export interface showMap {
	show_product: greaterShowpro
	products: product[][]
}
const GreaterSection = (props: { shows: greaterShow }) => {
	return (
		<>
			{props?.shows?.show_products != undefined &&
				Object.keys(props?.shows?.show_products)?.map((show_product, index: number) => {
					if (show_product.includes('Dental Extraction Kits') || show_product.includes('Anglevator')) {
						return null;
					}
					return <Greater show_product={show_product} key={index} products={props?.shows?.products[index]} index={index} />
				})}
		</>
	)
}

export default GreaterSection
